import { AddToCartTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/addToCart.trackingInfo";
import { RemoveFromCartTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/removeFromCart.trackingInfo";
import { ModelMapper } from "@omni/types/utils/modelMapper";

import { CartItemModel } from "@/redux/modules/api/data/cart/@types/cart.model";
import { TrackingProductModel } from "@/services/tracking/types/trackingProduct.model";

export const toTrackingProduct: ModelMapper<
    CartItemModel,
    TrackingProductModel
> = (product) => {
    return {
        id: product.sku,
        ean: product.ean,
        name: product.analytics?.productTitle || product.title,
        category: product.analytics?.superCategoryCode,
        price: product.salesPrice,
        unitPrice: product.salesPrice,
        tax: "21%",
        currencyCode: "EUR",
        brand: product.brandName ?? ""
    };
};

export const toAddToCartTrackingInfo: ModelMapper<
    { item: CartItemModel; quantity: number },
    AddToCartTrackingInfo
> = ({ item, quantity }) => {
    const { productTitle = "", superCategoryCode = "" } = item.analytics || {};
    const reduction =
        (item.strikethroughPrice ? item.strikethroughPrice : item.salesPrice) -
        item.salesPrice;

    return {
        name: productTitle || "",
        id: item.sku,
        ean: item.ean,
        category: superCategoryCode,
        price: item.salesPrice,
        unitPrice: item.salesPrice,
        tax: "21%",
        reduction: reduction,
        currencyCode: "EUR",
        quantity: quantity,
        url: item.url,
        brand: item.brandName || ""
    };
};

export const toRemoveFromCartTrackingInfo: ModelMapper<
    { item: CartItemModel; quantity: number },
    RemoveFromCartTrackingInfo
> = ({ item, quantity }) => {
    const { productTitle = "", superCategoryCode = "" } = item.analytics || {};
    const reduction =
        (item.strikethroughPrice ? item.strikethroughPrice : item.salesPrice) -
        item.salesPrice;

    return {
        name: productTitle || "",
        id: item.sku,
        ean: item.ean,
        category: superCategoryCode,
        price: item.salesPrice,
        unitPrice: item.salesPrice,
        tax: "21%",
        reduction: reduction,
        currencyCode: "EUR",
        quantity: quantity,
        url: item.url,
        brand: item.brandName || ""
    };
};
